import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

interface ArticleCardProps {
  id: string;
  title: string;
  excerpt: string;
  category: string;
  author: string;
  date: string;
  image: string;
  views: number;
  comments: number;
  featured?: boolean;
}

export default function ArticleCard({ id, title, excerpt, category, author, date, image, views, comments, featured }: ArticleCardProps) {
  const catInfo = categories.find((c) => c.id === category);

  return (
    <Link
      to={`/article/${id}`}
      className={`group block rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300 ${
        featured ? 'lg:col-span-2 lg:grid lg:grid-cols-2' : ''
      }`}
    >
      <div className={`relative overflow-hidden ${featured ? 'lg:h-full' : 'aspect-[16/10]'}`}>
        <img
          src={image}
          alt={title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          title={`${title} - 黑料社区`}
        />
        {featured && (
          <span className="absolute top-3 left-3 px-2.5 py-1 bg-primary-500 text-background-50 text-xs font-medium rounded-md">
            置顶
          </span>
        )}
      </div>

      <div className="p-4 md:p-5 flex flex-col gap-3">
        <div className="flex items-center gap-3 flex-wrap">
          {catInfo && (
            <span className="px-2 py-0.5 bg-accent-100 text-accent-900 text-xs font-medium rounded-md">
              {catInfo.name}
            </span>
          )}
          <span className="text-xs text-foreground-400">{date}</span>
        </div>

        <h3 className={`font-heading font-bold text-foreground-950 line-clamp-2 group-hover:text-primary-600 transition-colors ${
          featured ? 'text-xl md:text-2xl' : 'text-base md:text-lg'
        }`}>
          {title}
        </h3>

        <p className="text-sm text-foreground-500 line-clamp-2 leading-relaxed">
          {excerpt}
        </p>

        <div className="flex items-center justify-between mt-auto pt-2">
          <span className="text-xs text-foreground-400 flex items-center gap-1">
            <i className="ri-user-line"></i>
            {author}
          </span>
          <div className="flex items-center gap-3 text-xs text-foreground-400">
            <span className="flex items-center gap-1">
              <i className="ri-eye-line"></i>
              {views >= 10000 ? `${(views / 10000).toFixed(1)}万` : views}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-chat-3-line"></i>
              {comments}
            </span>
          </div>
        </div>
      </div>
    </Link>
  );
}